import Store from '../configureStore';

const syncState = () => {
  const {
    app,
    discovery,
    quiz,
    gamification,
    tracker,
    interactions
  } = Store.store.getState();
  iframeCall(`sync?data=${JSON.stringify({
    app,
    quiz,
    discovery,
    gamification,
    tracker,
    interactions
  })}`);
};

const iframeCall = (message) => {
  try {
    const { runsOn } = Store.store.getState().app;
    if (runsOn) {
      switch (runsOn.toLowerCase()) {
        case 'webapp':
        case 'rcaw':
          window.parent.postMessage(message, '*');
          break;

        case 'mobile':
          window.ReactNativeWebView.postMessage(message);
          break;

        default:
          window.ReactNativeWebView.postMessage(message);
          break;
      }
    } else {
      window.ReactNativeWebView.postMessage(message);
    }
  } catch (e) {
    // TODO: Log error
  }
};

const log = (data) => {
  try {
    iframeCall(`log?data=${JSON.stringify(data)}`);
  } catch (e) {
    iframeCall('log?data="Failed to log data"');
  }
};

export {
  syncState,
  iframeCall,
  log
};
